<script>
    import FormGroup from "./FormGroup.svelte";
    import addVariant from "src/utility/variant";

    export let variant;
    export let label;
    export let value;

    let fileInput;
    const onFileSelected = async (e) => {
        //value = await toBase64(e.target.files[0]);
        value = e.target.files[0];
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
</script>

<FormGroup {variant} {label}>
    <input
        class="pc__file"
        use:addVariant={variant}
        type="file"
        accept=".jpg, .jpeg, .png, .svg"
        on:change={(e) => onFileSelected(e)}
        bind:this={fileInput} />
</FormGroup>